export default __webpack_public_path__ + "static/media/about.77627f8c.png";